export var eventName = 'open-subscription-wizard';
export var openSubscriptionWizard = eventName;

/**
 * Dispatch event which open subscription or autoship wizard
 *
 * @param {CustomEventInit<EventData>} data data which will be passed to event
 * @param {('Subscription' | 'Autoship')} [data.detail.type=Subscription] type of wizard
 * @param {('All' | 'OnlyForMe' | 'OnlyForOtherCustomers')} [data.detail.customerType=All] type for which is wizard targeted
 * @param {string} [data.detail.initialProductCode] initial product code
 * @fires globalThis#open-subscription-wizard:open-subscription-wizard
 */
export function dispatch(data) {
  var event = new CustomEvent(eventName, data);
  globalThis.dispatchEvent(event);
}
/**
 * Listen callback for our event
 *
 * @callback listenCallback
 * @param {CustomEvent<EventData>} event - Event data
 * @returns {void}
 */

/**
 * Helper function which wraps event so we never miss.
 * @param {listenCallback} callback - That handles response
 * @param {(AddEventListenerOptions | boolean)} [options] - options of event
 */

export function listen(callback, options) {
  globalThis.addEventListener(eventName, callback, options);
}
/**
 * Clean event when you don't need to listen anymore.
 * @param {listenCallback} callback - that should be cleaned.
 */

export function clean(callback) {
  globalThis.removeEventListener(eventName, callback);
}
export default {
  dispatch: dispatch,
  listen: listen,
  clean: clean,
  eventName: eventName,
  openSubscriptionWizard: openSubscriptionWizard
};